"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const en_1 = require("../../../backend/src/app/acl_module/config/i18n/en");
const en_2 = __importDefault(require("./landing/en"));
const onboarding_tooltip_1 = __importDefault(require("./en/onboarding_tooltip"));
const app_page_1 = __importDefault(require("./en/app_page"));
const app_intext_1 = __importDefault(require("./en/app_intext"));
const modal_share_1 = __importDefault(require("./en/modal_share"));
const modal_settings_1 = __importDefault(require("./en/modal_settings"));
const chat_entry_1 = __importDefault(require("./en/chat_entry"));
const user_form_1 = __importDefault(require("./en/user_form"));
const slot_goal_1 = __importDefault(require("./en/slot_goal"));
const slot_target_1 = __importDefault(require("./en/slot_target"));
const slot_format_1 = __importDefault(require("./en/slot_format"));
const slotData_create_1 = __importDefault(require("./en/slotData_create"));
const slotData_load_1 = __importDefault(require("./en/slotData_load"));
const slotData_form_1 = __importDefault(require("./en/slotData_form"));
const slotData_type_1 = __importDefault(require("./en/slotData_type"));
const app_pagination_1 = __importDefault(require("./en/app_pagination"));
const payment_validation_1 = __importDefault(require("./en/payment_validation"));
const payment_status_1 = __importDefault(require("./en/payment_status"));
const payment_stripe_1 = __importDefault(require("./en/payment_stripe"));
const payment_provider_1 = __importDefault(require("./en/payment_provider"));
const payment_confirmed_1 = __importDefault(require("./en/payment_confirmed"));
const route_payment_1 = __importDefault(require("./en/route_payment"));
const payment_search_1 = __importDefault(require("./en/payment_search"));
const payment_preview_1 = __importDefault(require("./en/payment_preview"));
const user_roles_1 = __importDefault(require("./en/user_roles"));
const user_grade_1 = __importDefault(require("./en/user_grade"));
const userGroup_form_1 = __importDefault(require("./en/userGroup_form"));
const userGroup_error_1 = __importDefault(require("./en/userGroup_error"));
const route_userGroup_1 = __importDefault(require("./en/route_userGroup"));
const route_user_group_1 = __importDefault(require("./en/route_user_group"));
const company_preview_1 = __importDefault(require("./en/company_preview"));
const company_tooltips_1 = __importDefault(require("./en/company_tooltips"));
const access_status_1 = __importDefault(require("./en/access_status"));
const access_list_1 = __importDefault(require("./en/access_list"));
const avatar_processing_1 = __importDefault(require("./en/avatar_processing"));
const avatar_form_1 = __importDefault(require("./en/avatar_form"));
const webhook_eventTypes_1 = __importDefault(require("./en/webhook_eventTypes"));
const webhook_cronIntervals_1 = __importDefault(require("./en/webhook_cronIntervals"));
const tools_webSearch_1 = __importDefault(require("./en/tools_webSearch"));
const tools_imgGen_1 = __importDefault(require("./en/tools_imgGen"));
const tools_convoTags_1 = __importDefault(require("./en/tools_convoTags"));
const tools_galleryTags_1 = __importDefault(require("./en/tools_galleryTags"));
const tools_detectContactData_1 = __importDefault(require("./en/tools_detectContactData"));
const tools_detectTasks_1 = __importDefault(require("./en/tools_detectTasks"));
const tools_productCompare_1 = __importDefault(require("./en/tools_productCompare"));
const tools_askForVoucher_1 = __importDefault(require("./en/tools_askForVoucher"));
const tools_offerCreator_1 = __importDefault(require("./en/tools_offerCreator"));
const tools_quickOffer_1 = __importDefault(require("./en/tools_quickOffer"));
const tools_sendContactForm_1 = __importDefault(require("./en/tools_sendContactForm"));
const tools_apiTool_1 = __importDefault(require("./en/tools_apiTool"));
const tools_productAPISearch_1 = __importDefault(require("./en/tools_productAPISearch"));
const tools_dynamicListings_1 = __importDefault(require("./en/tools_dynamicListings"));
const tools_productCard_1 = __importDefault(require("./en/tools_productCard"));
const tools_personalData_1 = __importDefault(require("./en/tools_personalData"));
const tools_rag_1 = __importDefault(require("./en/tools_rag"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./en/tools_aiFormAnalyzer"));
const tools_communications_search_1 = __importDefault(require("./en/tools_communications_search"));
const avatar_common_1 = __importDefault(require("./en/avatar_common"));
const avatar_active_1 = __importDefault(require("./en/avatar_active"));
const avatar_tooltips_1 = __importDefault(require("./en/avatar_tooltips"));
const avatar_knowledge_1 = __importDefault(require("./en/avatar_knowledge"));
const avatar_preview_1 = __importDefault(require("./en/avatar_preview"));
const avatar_voiceAgent_1 = __importDefault(require("./en/avatar_voiceAgent"));
const botTest_preview_1 = __importDefault(require("./en/botTest_preview"));
const botTest_testResults_1 = __importDefault(require("./en/botTest_testResults"));
const accountGrade_list_1 = __importDefault(require("./en/accountGrade_list"));
const accountGrade_form_1 = __importDefault(require("./en/accountGrade_form"));
const limits_avatar_1 = __importDefault(require("./en/limits_avatar"));
const limits_user_1 = __importDefault(require("./en/limits_user"));
const limits_project_1 = __importDefault(require("./en/limits_project"));
const limits_knowledge_1 = __importDefault(require("./en/limits_knowledge"));
const limits_bulk_1 = __importDefault(require("./en/limits_bulk"));
const knowledge_bulk_upload_1 = __importDefault(require("./en/knowledge_bulk_upload"));
const limits_customModel_1 = __importDefault(require("./en/limits_customModel"));
const limits_writingStyles_1 = __importDefault(require("./en/limits_writingStyles"));
const limits_advanced_prompts_1 = __importDefault(require("./en/limits_advanced-prompts"));
const limits_prompt_assist_1 = __importDefault(require("./en/limits_prompt-assist"));
const limits_anti_hallucination_1 = __importDefault(require("./en/limits_anti-hallucination"));
const limits_advanced_reports_1 = __importDefault(require("./en/limits_advanced-reports"));
const limits_chat_thread_sharing_1 = __importDefault(require("./en/limits_chat-thread-sharing"));
const limits_custom_branding_1 = __importDefault(require("./en/limits_custom-branding"));
const limits_widgets_1 = __importDefault(require("./en/limits_widgets"));
const limits_voice_agent_1 = __importDefault(require("./en/limits_voice-agent"));
const limits_upgrade_1 = __importDefault(require("./en/limits_upgrade"));
const voice_chat_error_1 = __importDefault(require("./en/voice-chat_error"));
const email_pass_reset_1 = __importDefault(require("./en/email_pass_reset"));
const email_activation_1 = __importDefault(require("./en/email_activation"));
const email_upgrade_1 = __importDefault(require("./en/email_upgrade"));
const email_payment_1 = __importDefault(require("./en/email_payment"));
const register_complete_1 = __importDefault(require("./en/register_complete"));
const password_reset_1 = __importDefault(require("./en/password_reset"));
const accountGrade_preview_1 = __importDefault(require("./en/accountGrade_preview"));
const account_upgrade_1 = __importDefault(require("./en/account_upgrade"));
const account_grades_1 = __importDefault(require("./en/account_grades"));
const style_form_1 = __importDefault(require("./en/style_form"));
const style_preview_1 = __importDefault(require("./en/style_preview"));
const file_upload_1 = __importDefault(require("./en/file_upload"));
const file_clipboard_1 = __importDefault(require("./en/file_clipboard"));
const table_controls_1 = __importDefault(require("./en/table_controls"));
const login_username_1 = __importDefault(require("./en/login_username"));
const login_password_1 = __importDefault(require("./en/login_password"));
const login_form_1 = __importDefault(require("./en/login_form"));
const register_name_1 = __importDefault(require("./en/register_name"));
const register_username_1 = __importDefault(require("./en/register_username"));
const register_email_1 = __importDefault(require("./en/register_email"));
const register_password_1 = __importDefault(require("./en/register_password"));
const register_repeat_password_1 = __importDefault(require("./en/register_repeat_password"));
const register_form_1 = __importDefault(require("./en/register_form"));
const register_company_1 = __importDefault(require("./en/register_company"));
const activate_hero_1 = __importDefault(require("./en/activate_hero"));
const activate_page_1 = __importDefault(require("./en/activate_page"));
const activate_loading_1 = __importDefault(require("./en/activate_loading"));
const activate_success_1 = __importDefault(require("./en/activate_success"));
const activate_error_1 = __importDefault(require("./en/activate_error"));
const activate_button_1 = __importDefault(require("./en/activate_button"));
const route_ai_1 = __importDefault(require("./en/route_ai"));
const route_settings_1 = __importDefault(require("./en/route_settings"));
const route_reports_1 = __importDefault(require("./en/route_reports"));
const route_company_1 = __importDefault(require("./en/route_company"));
const route_user_1 = __importDefault(require("./en/route_user"));
const route_accountGrade_1 = __importDefault(require("./en/route_accountGrade"));
const route_branch_1 = __importDefault(require("./en/route_branch"));
const route_profession_1 = __importDefault(require("./en/route_profession"));
const route_avatar_1 = __importDefault(require("./en/route_avatar"));
const route_style_1 = __importDefault(require("./en/route_style"));
const route_conversation_1 = __importDefault(require("./en/route_conversation"));
const route_botTest_1 = __importDefault(require("./en/route_botTest"));
const route_tutorial_1 = __importDefault(require("./en/route_tutorial"));
const tutorial_create_1 = __importDefault(require("./en/tutorial_create"));
const tutorial_edit_1 = __importDefault(require("./en/tutorial_edit"));
const tutorial_preview_1 = __importDefault(require("./en/tutorial_preview"));
const tutorial_delete_1 = __importDefault(require("./en/tutorial_delete"));
const tutorial_list_1 = __importDefault(require("./en/tutorial_list"));
const tutorial_start_1 = __importDefault(require("./en/tutorial_start"));
const tutorial_new_section_1 = __importDefault(require("./en/tutorial_new-section"));
const tutorial_search_1 = __importDefault(require("./en/tutorial_search"));
const tutorial_form_1 = __importDefault(require("./en/tutorial_form"));
const tutorial_errors_1 = __importDefault(require("./en/tutorial_errors"));
const tutorial_validation_1 = __importDefault(require("./en/tutorial_validation"));
const tutorial_todos_1 = __importDefault(require("./en/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./en/tutorial_statistics"));
const botTest_create_1 = __importDefault(require("./en/botTest_create"));
const botTest_edit_1 = __importDefault(require("./en/botTest_edit"));
const botTest_tester_1 = __importDefault(require("./en/botTest_tester"));
const botTest_target_1 = __importDefault(require("./en/botTest_target"));
const botTest_list_1 = __importDefault(require("./en/botTest_list"));
const botTest_actions_1 = __importDefault(require("./en/botTest_actions"));
const ai_models_1 = __importDefault(require("./en/ai_models"));
const ai_com_1 = __importDefault(require("./en/ai_com"));
const ai_fields_1 = __importDefault(require("./en/ai_fields"));
const ai_controls_1 = __importDefault(require("./en/ai_controls"));
const ai_assist_suggestions_1 = __importDefault(require("./en/ai-assist_suggestions"));
const knowledge_picker_1 = __importDefault(require("./en/knowledge_picker"));
const ai_suggestions_1 = __importDefault(require("./en/ai_suggestions"));
const autocomplete_triggers_1 = __importDefault(require("./en/autocomplete_triggers"));
const ai_assist_1 = __importDefault(require("./en/ai_assist"));
const conversation_type_1 = __importDefault(require("./en/conversation_type"));
const conversation_agent_1 = __importDefault(require("./en/conversation_agent"));
const conversation_session_1 = __importDefault(require("./en/conversation_session"));
const conversation_avatar_1 = __importDefault(require("./en/conversation_avatar"));
const conversation_voice_1 = __importDefault(require("./en/conversation_voice"));
const conversation_user_1 = __importDefault(require("./en/conversation_user"));
const conversation_clear_1 = __importDefault(require("./en/conversation_clear"));
const share_conversation_1 = __importDefault(require("./en/share_conversation"));
const conversation_auto_1 = __importDefault(require("./en/conversation_auto"));
const conversation_start_1 = __importDefault(require("./en/conversation_start"));
const conversation_stop_1 = __importDefault(require("./en/conversation_stop"));
const conversation_recording_1 = __importDefault(require("./en/conversation_recording"));
const conversation_processing_1 = __importDefault(require("./en/conversation_processing"));
const conversation_interruption_1 = __importDefault(require("./en/conversation_interruption"));
const conversation_end_1 = __importDefault(require("./en/conversation_end"));
const recording_start_1 = __importDefault(require("./en/recording_start"));
const recording_process_1 = __importDefault(require("./en/recording_process"));
const message_send_1 = __importDefault(require("./en/message_send"));
const microphone_access_1 = __importDefault(require("./en/microphone_access"));
const conversations_search_1 = __importDefault(require("./en/conversations_search"));
const conversations_date_1 = __importDefault(require("./en/conversations_date"));
const conversations_error_1 = __importDefault(require("./en/conversations_error"));
const conversations_delete_1 = __importDefault(require("./en/conversations_delete"));
const conversations_favorite_1 = __importDefault(require("./en/conversations_favorite"));
const conversations_tooltips_1 = __importDefault(require("./en/conversations_tooltips"));
const route_knowledge_1 = __importDefault(require("./en/route_knowledge"));
const route_knowledgeProject_1 = __importDefault(require("./en/route_knowledgeProject"));
const user_profile_1 = __importDefault(require("./en/user_profile"));
const company_form_1 = __importDefault(require("./en/company_form"));
const knowledge_form_1 = __importDefault(require("./en/knowledge_form"));
const knowledge_tags_1 = __importDefault(require("./en/knowledge_tags"));
const knowledge_native_1 = __importDefault(require("./en/knowledge_native"));
const knowledge_active_1 = __importDefault(require("./en/knowledge_active"));
const knowledge_filter_1 = __importDefault(require("./en/knowledge_filter"));
const knowledge_ragStatus_1 = __importDefault(require("./en/knowledge_ragStatus"));
const knowledge_statusInfo_1 = __importDefault(require("./en/knowledge_statusInfo"));
const knowledge_preview_1 = __importDefault(require("./en/knowledge_preview"));
const project_form_1 = __importDefault(require("./en/project_form"));
const project_name_1 = __importDefault(require("./en/project_name"));
const project_description_1 = __importDefault(require("./en/project_description"));
const project_icon_1 = __importDefault(require("./en/project_icon"));
const branch_list_1 = __importDefault(require("./en/branch_list"));
const branch_create_1 = __importDefault(require("./en/branch_create"));
const branch_edit_1 = __importDefault(require("./en/branch_edit"));
const branch_search_1 = __importDefault(require("./en/branch_search"));
const branch_delete_1 = __importDefault(require("./en/branch_delete"));
const branch_form_1 = __importDefault(require("./en/branch_form"));
const profession_list_1 = __importDefault(require("./en/profession_list"));
const profession_create_1 = __importDefault(require("./en/profession_create"));
const profession_edit_1 = __importDefault(require("./en/profession_edit"));
const profession_search_1 = __importDefault(require("./en/profession_search"));
const profession_delete_1 = __importDefault(require("./en/profession_delete"));
const profession_form_1 = __importDefault(require("./en/profession_form"));
const step_list_1 = __importDefault(require("./en/step_list"));
const step_create_1 = __importDefault(require("./en/step_create"));
const step_edit_1 = __importDefault(require("./en/step_edit"));
const step_search_1 = __importDefault(require("./en/step_search"));
const step_delete_1 = __importDefault(require("./en/step_delete"));
const step_form_1 = __importDefault(require("./en/step_form"));
const question_list_1 = __importDefault(require("./en/question_list"));
const question_create_1 = __importDefault(require("./en/question_create"));
const question_edit_1 = __importDefault(require("./en/question_edit"));
const question_search_1 = __importDefault(require("./en/question_search"));
const question_delete_1 = __importDefault(require("./en/question_delete"));
const question_form_1 = __importDefault(require("./en/question_form"));
const question_type_1 = __importDefault(require("./en/question_type"));
const onboarding_intro_1 = __importDefault(require("./en/onboarding_intro"));
const onboarding_list_1 = __importDefault(require("./en/onboarding_list"));
const onboarding_create_1 = __importDefault(require("./en/onboarding_create"));
const onboarding_edit_1 = __importDefault(require("./en/onboarding_edit"));
const onboarding_search_1 = __importDefault(require("./en/onboarding_search"));
const onboarding_delete_1 = __importDefault(require("./en/onboarding_delete"));
const onboarding_avatar_1 = __importDefault(require("./en/onboarding_avatar"));
const onboarding_progress_1 = __importDefault(require("./en/onboarding_progress"));
const onboarding_knowledge_1 = __importDefault(require("./en/onboarding_knowledge"));
const onboarding_status_1 = __importDefault(require("./en/onboarding_status"));
const onboarding_stats_1 = __importDefault(require("./en/onboarding_stats"));
const onboarding_wizard_1 = __importDefault(require("./en/onboarding_wizard"));
const onboarding_benefits_1 = __importDefault(require("./en/onboarding_benefits"));
const onboarding_button_1 = __importDefault(require("./en/onboarding_button"));
const onboarding_image_1 = __importDefault(require("./en/onboarding_image"));
const onboarding_faq_1 = __importDefault(require("./en/onboarding_faq"));
const onboarding_setup_1 = __importDefault(require("./en/onboarding_setup"));
const onboarding_profession_1 = __importDefault(require("./en/onboarding_profession"));
const voices_david_1 = __importDefault(require("./en/voices_david"));
const voices_bradford_1 = __importDefault(require("./en/voices_bradford"));
const voices_clyde_1 = __importDefault(require("./en/voices_clyde"));
const voices_natalie_1 = __importDefault(require("./en/voices_natalie"));
const voices_jane_1 = __importDefault(require("./en/voices_jane"));
const voices_magdalena_1 = __importDefault(require("./en/voices_magdalena"));
const onboarding_records_1 = __importDefault(require("./en/onboarding_records"));
const onboarding_record_1 = __importDefault(require("./en/onboarding_record"));
const onboarding_warning_1 = __importDefault(require("./en/onboarding_warning"));
const onboarding_questions_1 = __importDefault(require("./en/onboarding_questions"));
const onboarding_pagination_1 = __importDefault(require("./en/onboarding_pagination"));
const onboarding_view_1 = __importDefault(require("./en/onboarding_view"));
const onboarding_pick_1 = __importDefault(require("./en/onboarding_pick"));
const onboarding_error_1 = __importDefault(require("./en/onboarding_error"));
const onboarding_success_1 = __importDefault(require("./en/onboarding_success"));
const onboarding_notify_1 = __importDefault(require("./en/onboarding_notify"));
const chat_teaser_1 = __importDefault(require("./en/chat_teaser"));
const chat_heading_1 = __importDefault(require("./en/chat_heading"));
const chat_page_1 = __importDefault(require("./en/chat_page"));
const chat_config_1 = __importDefault(require("./en/chat_config"));
const chat_noCredits_1 = __importDefault(require("./en/chat_noCredits"));
const chat_sync_1 = __importDefault(require("./en/chat_sync"));
const trainer_reset_1 = __importDefault(require("./en/trainer_reset"));
const trainer_tab_1 = __importDefault(require("./en/trainer_tab"));
const trainer_upload_1 = __importDefault(require("./en/trainer_upload"));
const trainer_config_1 = __importDefault(require("./en/trainer_config"));
const trainer_progress_1 = __importDefault(require("./en/trainer_progress"));
const trainer_results_1 = __importDefault(require("./en/trainer_results"));
const trainer_instructions_1 = __importDefault(require("./en/trainer_instructions"));
const profession_common_1 = __importDefault(require("./en/profession_common"));
const step_shared_1 = __importDefault(require("./en/step_shared"));
const settings_general_1 = __importDefault(require("./en/settings_general"));
const settings_socialMedia_1 = __importDefault(require("./en/settings_socialMedia"));
const settings_status_1 = __importDefault(require("./en/settings_status"));
const settings_rag_1 = __importDefault(require("./en/settings_rag"));
const settings_credit_1 = __importDefault(require("./en/settings_credit"));
const rag_file_1 = __importDefault(require("./en/rag_file"));
const rag_settings_1 = __importDefault(require("./en/rag_settings"));
const settings_googleDrive_1 = __importDefault(require("./en/settings_googleDrive"));
const googleDrive_picker_1 = __importDefault(require("./en/googleDrive_picker"));
const googleDrive_directoryPicker_1 = __importDefault(require("./en/googleDrive_directoryPicker"));
const reports_access_1 = __importDefault(require("./en/reports_access"));
const reports_costReports_1 = __importDefault(require("./en/reports_costReports"));
const reports_export_1 = __importDefault(require("./en/reports_export"));
const reports_period_1 = __importDefault(require("./en/reports_period"));
const cost_preview_1 = __importDefault(require("./en/cost_preview"));
const chat_settings_1 = __importDefault(require("./en/chat_settings"));
const config_tooltips_1 = __importDefault(require("./en/config_tooltips"));
const reports_shared_1 = __importDefault(require("./en/reports_shared"));
const acl_table_1 = __importDefault(require("./en/acl_table"));
const shortcuts_button_1 = __importDefault(require("./en/shortcuts_button"));
const shortcuts_table_1 = __importDefault(require("./en/shortcuts_table"));
const shortcuts_knowledge_1 = __importDefault(require("./en/shortcuts_knowledge"));
const shortcuts_new_1 = __importDefault(require("./en/shortcuts_new"));
const shortcuts_settings_1 = __importDefault(require("./en/shortcuts_settings"));
const shortcuts_find_1 = __importDefault(require("./en/shortcuts_find"));
const shortcuts_prompt_1 = __importDefault(require("./en/shortcuts_prompt"));
const currency_error_1 = __importDefault(require("./en/currency_error"));
const nav_avatar_1 = __importDefault(require("./en/nav_avatar"));
const nav_model_1 = __importDefault(require("./en/nav_model"));
const nav_ai_1 = __importDefault(require("./en/nav_ai"));
const knowledge_bulkUpload_1 = __importDefault(require("./en/knowledge_bulkUpload"));
const dblogs_filter_1 = __importDefault(require("./en/dblogs_filter"));
const dblogs_results_1 = __importDefault(require("./en/dblogs_results"));
const dblogs_col_1 = __importDefault(require("./en/dblogs_col"));
const dblogs_error_1 = __importDefault(require("./en/dblogs_error"));
const dblogs_search_1 = __importDefault(require("./en/dblogs_search"));
const dblogs_page_1 = __importDefault(require("./en/dblogs_page"));
const route_dblogs_1 = __importDefault(require("./en/route_dblogs"));
const db_operation_1 = __importDefault(require("./en/db_operation"));
const socialMediaPlan_wip_1 = __importDefault(require("./en/socialMediaPlan_wip"));
const socialMediaPlan_nav_1 = __importDefault(require("./en/socialMediaPlan_nav"));
const socialMediaPlan_dashboard_1 = __importDefault(require("./en/socialMediaPlan_dashboard"));
const socialMediaPlan_stat_1 = __importDefault(require("./en/socialMediaPlan_stat"));
const socialMediaPlan_tab_1 = __importDefault(require("./en/socialMediaPlan_tab"));
const socialMediaPlan_history_1 = __importDefault(require("./en/socialMediaPlan_history"));
const socialMediaPlan_library_1 = __importDefault(require("./en/socialMediaPlan_library"));
const socialMediaPlan_filter_1 = __importDefault(require("./en/socialMediaPlan_filter"));
const socialMediaPlan_drawer_1 = __importDefault(require("./en/socialMediaPlan_drawer"));
const socialMediaPlan_post_1 = __importDefault(require("./en/socialMediaPlan_post"));
const socialMediaPlan_approvalQueue_1 = __importDefault(require("./en/socialMediaPlan_approvalQueue"));
const socialMediaPlan_ai_1 = __importDefault(require("./en/socialMediaPlan_ai"));
const socialMediaPlan_channels_1 = __importDefault(require("./en/socialMediaPlan_channels"));
const socialMediaPlan_analytics_1 = __importDefault(require("./en/socialMediaPlan_analytics"));
const socialMediaPlan_creator_1 = __importDefault(require("./en/socialMediaPlan_creator"));
const socialMediaPlan_platformNotConnected_1 = __importDefault(require("./en/socialMediaPlan_platformNotConnected"));
const socialMediaPlan_brief_1 = __importDefault(require("./en/socialMediaPlan_brief"));
const socialMediaPlan_schedule_1 = __importDefault(require("./en/socialMediaPlan_schedule"));
const socialMediaPlan_step_1 = __importDefault(require("./en/socialMediaPlan_step"));
const whatsapp_settingsList_1 = __importDefault(require("./en/whatsapp_settingsList"));
const whatsapp_settingsForm_1 = __importDefault(require("./en/whatsapp_settingsForm"));
const whatsapp_settings_1 = __importDefault(require("./en/whatsapp_settings"));
const whatsapp_tabs_1 = __importDefault(require("./en/whatsapp_tabs"));
const whatsapp_threads_1 = __importDefault(require("./en/whatsapp_threads"));
const whatsapp_trackLog_1 = __importDefault(require("./en/whatsapp_trackLog"));
const whatsapp_email_1 = __importDefault(require("./en/whatsapp_email"));
const whatsapp_groups_1 = __importDefault(require("./en/whatsapp_groups"));
const whatsapp_commsType_1 = __importDefault(require("./en/whatsapp_commsType"));
const whatsapp_sourceType_1 = __importDefault(require("./en/whatsapp_sourceType"));
const whatsapp_dm_1 = __importDefault(require("./en/whatsapp_dm"));
const activities_panel_1 = __importDefault(require("./en/activities_panel"));
const whatsapp_groupForm_1 = __importDefault(require("./en/whatsapp_groupForm"));
const whatsapp_dashboard_1 = __importDefault(require("./en/whatsapp_dashboard"));
const route_whatsapp_1 = __importDefault(require("./en/route_whatsapp"));
const whatsapp_directMessages_1 = __importDefault(require("./en/whatsapp_directMessages"));
exports.default = {
    ...onboarding_tooltip_1.default,
    ...app_page_1.default,
    ...app_intext_1.default,
    ...modal_share_1.default,
    ...modal_settings_1.default,
    ...chat_entry_1.default,
    ...user_form_1.default,
    ...slot_goal_1.default,
    ...slot_target_1.default,
    ...slot_format_1.default,
    ...slotData_create_1.default,
    ...slotData_load_1.default,
    ...slotData_form_1.default,
    ...slotData_type_1.default,
    ...app_pagination_1.default,
    ...payment_validation_1.default,
    ...payment_status_1.default,
    ...payment_stripe_1.default,
    ...payment_provider_1.default,
    ...payment_confirmed_1.default,
    ...route_payment_1.default,
    ...payment_search_1.default,
    ...payment_preview_1.default,
    ...user_roles_1.default,
    ...user_grade_1.default,
    ...userGroup_form_1.default,
    ...userGroup_error_1.default,
    ...route_userGroup_1.default,
    ...route_user_group_1.default,
    ...company_preview_1.default,
    ...company_tooltips_1.default,
    ...access_status_1.default,
    ...access_list_1.default,
    ...avatar_processing_1.default,
    ...avatar_form_1.default,
    ...webhook_eventTypes_1.default,
    ...webhook_cronIntervals_1.default,
    ...tools_webSearch_1.default,
    ...tools_imgGen_1.default,
    ...tools_convoTags_1.default,
    ...tools_galleryTags_1.default,
    ...tools_detectContactData_1.default,
    ...tools_detectTasks_1.default,
    ...tools_productCompare_1.default,
    ...tools_askForVoucher_1.default,
    ...tools_offerCreator_1.default,
    ...tools_quickOffer_1.default,
    ...tools_sendContactForm_1.default,
    ...tools_apiTool_1.default,
    ...tools_productAPISearch_1.default,
    ...tools_dynamicListings_1.default,
    ...tools_productCard_1.default,
    ...tools_personalData_1.default,
    ...tools_rag_1.default,
    ...tools_aiFormAnalyzer_1.default,
    ...tools_communications_search_1.default,
    ...avatar_common_1.default,
    ...avatar_active_1.default,
    ...avatar_tooltips_1.default,
    ...avatar_knowledge_1.default,
    ...avatar_preview_1.default,
    ...avatar_voiceAgent_1.default,
    ...botTest_preview_1.default,
    ...botTest_testResults_1.default,
    ...accountGrade_list_1.default,
    ...accountGrade_form_1.default,
    ...limits_avatar_1.default,
    ...limits_user_1.default,
    ...limits_project_1.default,
    ...limits_knowledge_1.default,
    ...limits_bulk_1.default,
    ...knowledge_bulk_upload_1.default,
    ...limits_customModel_1.default,
    ...limits_writingStyles_1.default,
    ...limits_advanced_prompts_1.default,
    ...limits_prompt_assist_1.default,
    ...limits_anti_hallucination_1.default,
    ...limits_advanced_reports_1.default,
    ...limits_chat_thread_sharing_1.default,
    ...limits_custom_branding_1.default,
    ...limits_widgets_1.default,
    ...limits_voice_agent_1.default,
    ...limits_upgrade_1.default,
    ...voice_chat_error_1.default,
    ...email_pass_reset_1.default,
    ...email_activation_1.default,
    ...email_upgrade_1.default,
    ...email_payment_1.default,
    ...register_complete_1.default,
    ...password_reset_1.default,
    ...accountGrade_preview_1.default,
    ...account_upgrade_1.default,
    ...account_grades_1.default,
    ...style_form_1.default,
    ...style_preview_1.default,
    ...file_upload_1.default,
    ...file_clipboard_1.default,
    ...table_controls_1.default,
    ...login_username_1.default,
    ...login_password_1.default,
    ...login_form_1.default,
    ...register_name_1.default,
    ...register_username_1.default,
    ...register_email_1.default,
    ...register_password_1.default,
    ...register_repeat_password_1.default,
    ...register_form_1.default,
    ...register_company_1.default,
    ...activate_hero_1.default,
    ...activate_page_1.default,
    ...activate_loading_1.default,
    ...activate_success_1.default,
    ...activate_error_1.default,
    ...activate_button_1.default,
    ...route_ai_1.default,
    ...route_settings_1.default,
    ...route_reports_1.default,
    ...route_company_1.default,
    ...route_user_1.default,
    ...route_accountGrade_1.default,
    ...route_branch_1.default,
    ...route_profession_1.default,
    ...route_avatar_1.default,
    ...route_style_1.default,
    ...route_conversation_1.default,
    ...route_botTest_1.default,
    ...route_tutorial_1.default,
    ...tutorial_create_1.default,
    ...tutorial_edit_1.default,
    ...tutorial_preview_1.default,
    ...tutorial_delete_1.default,
    ...tutorial_list_1.default,
    ...tutorial_start_1.default,
    ...tutorial_new_section_1.default,
    ...tutorial_search_1.default,
    ...tutorial_form_1.default,
    ...tutorial_errors_1.default,
    ...tutorial_validation_1.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...botTest_create_1.default,
    ...botTest_edit_1.default,
    ...botTest_tester_1.default,
    ...botTest_target_1.default,
    ...botTest_list_1.default,
    ...botTest_actions_1.default,
    ...ai_models_1.default,
    ...ai_com_1.default,
    ...ai_fields_1.default,
    ...ai_controls_1.default,
    ...ai_assist_suggestions_1.default,
    ...knowledge_picker_1.default,
    ...ai_suggestions_1.default,
    ...autocomplete_triggers_1.default,
    ...ai_assist_1.default,
    ...conversation_type_1.default,
    ...conversation_agent_1.default,
    ...conversation_session_1.default,
    ...conversation_avatar_1.default,
    ...conversation_voice_1.default,
    ...conversation_user_1.default,
    ...conversation_clear_1.default,
    ...share_conversation_1.default,
    ...conversation_auto_1.default,
    ...conversation_start_1.default,
    ...conversation_stop_1.default,
    ...conversation_recording_1.default,
    ...conversation_processing_1.default,
    ...conversation_interruption_1.default,
    ...conversation_end_1.default,
    ...recording_start_1.default,
    ...recording_process_1.default,
    ...message_send_1.default,
    ...microphone_access_1.default,
    ...conversations_search_1.default,
    ...conversations_date_1.default,
    ...conversations_error_1.default,
    ...conversations_delete_1.default,
    ...conversations_favorite_1.default,
    ...conversations_tooltips_1.default,
    ...route_knowledge_1.default,
    ...route_knowledgeProject_1.default,
    ...user_profile_1.default,
    ...company_form_1.default,
    ...knowledge_form_1.default,
    ...knowledge_tags_1.default,
    ...knowledge_native_1.default,
    ...knowledge_active_1.default,
    ...knowledge_filter_1.default,
    ...knowledge_ragStatus_1.default,
    ...knowledge_statusInfo_1.default,
    ...knowledge_preview_1.default,
    ...project_form_1.default,
    ...project_name_1.default,
    ...project_description_1.default,
    ...project_icon_1.default,
    ...branch_list_1.default,
    ...branch_create_1.default,
    ...branch_edit_1.default,
    ...branch_search_1.default,
    ...branch_delete_1.default,
    ...branch_form_1.default,
    ...profession_list_1.default,
    ...profession_create_1.default,
    ...profession_edit_1.default,
    ...profession_search_1.default,
    ...profession_delete_1.default,
    ...profession_form_1.default,
    ...step_list_1.default,
    ...step_create_1.default,
    ...step_edit_1.default,
    ...step_search_1.default,
    ...step_delete_1.default,
    ...step_form_1.default,
    ...question_list_1.default,
    ...question_create_1.default,
    ...question_edit_1.default,
    ...question_search_1.default,
    ...question_delete_1.default,
    ...question_form_1.default,
    ...question_type_1.default,
    ...onboarding_intro_1.default,
    ...onboarding_list_1.default,
    ...onboarding_create_1.default,
    ...onboarding_edit_1.default,
    ...onboarding_search_1.default,
    ...onboarding_delete_1.default,
    ...onboarding_avatar_1.default,
    ...onboarding_progress_1.default,
    ...onboarding_knowledge_1.default,
    ...onboarding_status_1.default,
    ...onboarding_stats_1.default,
    ...onboarding_wizard_1.default,
    ...onboarding_benefits_1.default,
    ...onboarding_button_1.default,
    ...onboarding_image_1.default,
    ...onboarding_faq_1.default,
    ...onboarding_setup_1.default,
    ...onboarding_profession_1.default,
    ...voices_david_1.default,
    ...voices_bradford_1.default,
    ...voices_clyde_1.default,
    ...voices_natalie_1.default,
    ...voices_jane_1.default,
    ...voices_magdalena_1.default,
    ...onboarding_records_1.default,
    ...onboarding_record_1.default,
    ...onboarding_warning_1.default,
    ...onboarding_questions_1.default,
    ...onboarding_pagination_1.default,
    ...onboarding_view_1.default,
    ...onboarding_pick_1.default,
    ...onboarding_error_1.default,
    ...onboarding_success_1.default,
    ...onboarding_notify_1.default,
    ...chat_teaser_1.default,
    ...chat_heading_1.default,
    ...chat_page_1.default,
    ...chat_config_1.default,
    ...chat_noCredits_1.default,
    ...chat_sync_1.default,
    ...trainer_reset_1.default,
    ...trainer_tab_1.default,
    ...trainer_upload_1.default,
    ...trainer_config_1.default,
    ...trainer_progress_1.default,
    ...trainer_results_1.default,
    ...trainer_instructions_1.default,
    ...profession_common_1.default,
    ...step_shared_1.default,
    ...settings_general_1.default,
    ...settings_socialMedia_1.default,
    ...settings_status_1.default,
    ...settings_rag_1.default,
    ...settings_credit_1.default,
    ...rag_file_1.default,
    ...rag_settings_1.default,
    ...settings_googleDrive_1.default,
    ...googleDrive_picker_1.default,
    ...googleDrive_directoryPicker_1.default,
    ...reports_access_1.default,
    ...reports_costReports_1.default,
    ...reports_export_1.default,
    ...reports_period_1.default,
    ...cost_preview_1.default,
    ...chat_settings_1.default,
    ...config_tooltips_1.default,
    ...reports_shared_1.default,
    ...acl_table_1.default,
    ...shortcuts_button_1.default,
    ...shortcuts_table_1.default,
    ...shortcuts_knowledge_1.default,
    ...shortcuts_new_1.default,
    ...shortcuts_settings_1.default,
    ...shortcuts_find_1.default,
    ...shortcuts_prompt_1.default,
    ...currency_error_1.default,
    ...nav_avatar_1.default,
    ...nav_model_1.default,
    ...nav_ai_1.default,
    ...knowledge_bulkUpload_1.default,
    ...dblogs_filter_1.default,
    ...dblogs_results_1.default,
    ...dblogs_col_1.default,
    ...dblogs_error_1.default,
    ...dblogs_search_1.default,
    ...dblogs_page_1.default,
    ...route_dblogs_1.default,
    ...db_operation_1.default,
    ...socialMediaPlan_wip_1.default,
    ...socialMediaPlan_nav_1.default,
    ...socialMediaPlan_dashboard_1.default,
    ...socialMediaPlan_stat_1.default,
    ...socialMediaPlan_tab_1.default,
    ...socialMediaPlan_history_1.default,
    ...socialMediaPlan_library_1.default,
    ...socialMediaPlan_filter_1.default,
    ...socialMediaPlan_drawer_1.default,
    ...socialMediaPlan_post_1.default,
    ...socialMediaPlan_approvalQueue_1.default,
    ...socialMediaPlan_ai_1.default,
    ...socialMediaPlan_channels_1.default,
    ...socialMediaPlan_analytics_1.default,
    ...socialMediaPlan_creator_1.default,
    ...socialMediaPlan_platformNotConnected_1.default,
    ...socialMediaPlan_brief_1.default,
    ...socialMediaPlan_schedule_1.default,
    ...socialMediaPlan_step_1.default,
    ...whatsapp_settingsList_1.default,
    ...whatsapp_settingsForm_1.default,
    ...whatsapp_settings_1.default,
    ...whatsapp_tabs_1.default,
    ...whatsapp_threads_1.default,
    ...whatsapp_trackLog_1.default,
    ...whatsapp_email_1.default,
    ...whatsapp_groups_1.default,
    ...whatsapp_commsType_1.default,
    ...whatsapp_sourceType_1.default,
    ...whatsapp_dm_1.default,
    ...activities_panel_1.default,
    ...whatsapp_groupForm_1.default,
    ...whatsapp_dashboard_1.default,
    ...route_whatsapp_1.default,
    ...whatsapp_directMessages_1.default,
    ...en_2.default,
    // App basics
    'acl_resource.knowledge_group': 'Knowledge Group',
    'acl_resource.payment': 'Payment',
    'acl_resource.botTest': 'Bot Test',
    'app.name': "IntHub",
    'app.removed': 'Removed',
    'app.share': 'Share',
    'app.share_link': 'Share Link',
    'app.co_share': 'Share with users',
    // Modal headers
    // Chat
    // Navigation
    'profile': 'Profile',
    'messages': 'Messages',
    'logout': 'Log out',
    'lang.en': 'English',
    'lang.de': 'German',
    'lang.es': 'Spanish',
    'lang.it': 'Italian',
    'lang.pl': 'Polish',
    'lang.zh': 'Chinese',
    // User form language fields
    // Slot options
    'slot.none': 'None',
    // Slot placeholders
    'slot.prompt_context': 'Topic',
    'slot.conversation_goal': 'Conversation goal',
    'slot.conversation_target': 'Target audience',
    'slot.conversation_format': 'Output format',
    // Slot data management
    'slot-data.created': 'Slot data created successfully',
    'slot-data.deleted': 'Slot data deleted successfully',
    // Pagination & Search
    'pagination.itemsPerPage': 'Items per page',
    'pagination.ellipsis': '…',
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'search.placeholder': 'Search...',
    'search.clear': 'Clear search',
    // CRUD operations
    'crud.create': 'Create',
    'crud.edit': 'Edit',
    'crud.delete': 'Delete',
    'crud.preview': 'Preview',
    'crud.saving': 'Saving...',
    'crud.filtering': 'Filtering',
    'crud.searchPlaceholder': 'Search...',
    'crud.noCompanies': 'No companies found',
    'crud.noEntries': 'No entries found',
    'crud.failedToLoad': 'Failed to load data',
    'crud.confirmDelete': 'Are you sure you want to delete',
    'crud.deletedSuccessfully': 'Deleted successfully',
    'crud.failedToDelete': 'Failed to delete',
    'crud.cantEditItem': 'This item cannot be edited',
    'crud.cantDeleteItem': 'This item cannot be deleted',
    // Form operations
    'form.back': 'Back',
    // Common status terms
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.common': 'Common',
    'common.free': 'Free',
    'common.unlimited': 'Unlimited',
    'common.ordering': 'Ordering',
    'common.createdAt': 'Created At',
    // Payment
    'payment.gateway': 'Payment Gateway',
    'payment.provider': 'Payment Provider',
    'payment.amount': 'Amount',
    'payment.description': 'Description',
    'payment.sessionId': 'Session ID',
    'payment.id': 'Payment ID',
    'payment.status': 'Payment Status',
    'payment.currentStatus': 'Current Status',
    'payment.initiate': 'Initialize Payment',
    'payment.testConnection': 'Test Connection',
    'payment.refreshStatus': 'Refresh Status',
    'payment.reset': 'Reset Payment',
    'payment.defaultDescription': 'Payment transaction',
    'payment.initialized': 'Payment initialized successfully',
    'payment.initializationFailed': 'Payment initialization failed',
    'payment.successful': 'Payment completed successfully',
    'payment.pending': 'Payment is pending',
    'payment.rejected': 'Payment was rejected',
    'payment.error': 'Payment error occurred',
    'payment.connectionSuccessful': 'Payment provider connection successful',
    'payment.connectionFailed': 'Payment provider connection failed',
    'payment.statusCheckFailed': 'Failed to check payment status',
    'payment.noPaymentId': 'No payment ID available',
    'payment.processing': 'Processing...',
    'payment.confirmationFailed': 'Payment confirmation failed',
    'payment.selectProvider': 'Select Payment Provider',
    'payment.operationName': 'Payment Operation',
    'payment.unsupportedProvider': 'Unsupported payment provider',
    // Payment List & Preview
    'payment.user': 'User',
    'payment.email': 'Email',
    'payment.targetGrade': 'Target Grade',
    'payment.paidAt': 'Paid At',
    'payment.failureReason': 'Failure Reason',
    'payment.details': 'Payment Details',
    'payment.timeline': 'Timeline',
    'payment.created': 'Created',
    'payment.updated': 'Updated',
    'payment.technicalDetails': 'Technical Details',
    'payment.stripePaymentIntentId': 'Stripe Payment Intent ID',
    'payment.stripeCustomerId': 'Stripe Customer ID',
    'payment.orderId': 'Order ID',
    'payment.metadata': 'Metadata',
    // Gender
    'gender.male': 'Male',
    'gender.female': 'Female',
    'searchUser.users': 'Users',
    'searchUser.searchPlaceholder': 'Search users...',
    'searchUser.selectedParticipants': 'Selected Participants',
    'searchUser.availableUsers': 'Available Users',
    'searchUser.noUsersFound': 'No users found matching your search.',
    'searchUser.failedToLoadUsers': 'Failed to load users',
    // User List Columns
    'user.name': 'Name',
    'user.last_name': 'Last Name',
    'user.username': 'Username',
    'user.email': 'Email',
    'user.parent': 'Parent user',
    'user.role': 'Role',
    'user.status': 'Status',
    'user.company': 'Company',
    // User list page
    'user.listTitle': 'Users',
    'user.addUser': 'Add user',
    'user.searchPlaceholder': 'Search users...',
    // User list component (for non-admin users)
    'userList.title': 'Team Members',
    'userList.description': 'Connect and collaborate with your team members',
    'userList.searchPlaceholder': 'Search team members...',
    'userList.noUsers': 'No team members found',
    'userList.loading': 'Loading team members...',
    'userList.online': 'Online',
    'userList.offline': 'Offline',
    'userList.lastSeen': 'Last seen',
    'userList.startChat': 'Start Chat',
    'userList.viewProfile': 'View Profile',
    // User Group List Columns
    'userGroup.name': 'Name',
    'userGroup.description': 'Description',
    'userGroup.active': 'Active',
    'userGroup.owner': 'Owner',
    'userGroup.userCount': 'Users Count',
    // User Group list page
    'userGroup.listTitle': 'User Groups',
    'userGroup.addUserGroup': 'Add User Group',
    'userGroup.searchPlaceholder': 'Search user groups...',
    // User Group form page
    'userGroup.create': 'Create User Group',
    // User form
    // Routes
    // Company List Columns
    'company.name': 'Name',
    'company.nip': 'NIP',
    'company.email': 'Email',
    'company.phone': 'Phone',
    'company.city': 'City',
    'company.address': 'Address',
    'company.street': 'Street',
    'company.postalCode': 'Postal Code',
    'company.website': 'Website',
    'company.description': 'Description',
    'company.modules': 'Modules',
    'company.active': 'Active',
    // Company Preview & Tooltips
    // Access Settings Columns
    'access.user_or_company': 'User / Company',
    'access.user_group': 'User Group',
    'access.policies': 'Access Policies',
    'access.active': 'Active',
    // Avatar List Columns
    'avatar.image': 'Image',
    'avatar.name': 'Name',
    'avatar.avatar': 'Avatar',
    'avatar.gender': 'Gender',
    'avatar.age': 'Age',
    'avatar.model': 'Model',
    'avatar.onboarded': 'Onboarded',
    'avatar.processing': 'Processing',
    'avatar.description': 'Description',
    // Avatar list page
    'avatar.listTitle': 'Assistants',
    'avatar.noAvatars': 'No assistants found',
    'avatar.addAvatar': 'Add Assistant',
    'avatar.searchPlaceholder': 'Search assistant...',
    'avatar.listView': 'List View',
    'avatar.gridView': 'Grid View',
    // Avatar form knowledge section
    // Avatar form page
    // Webhook configuration
    // Webhook definitions
    // Webhook payload examples
    // Webhook event types
    // Webhook cron intervals
    // Lexicon configuration
    // API Tools
    'apiTool.requestSent': 'Request sent',
    'apiTool.requestFailed': 'Request failed',
    'apiTool.collectingData': 'Collecting data...',
    'apiTool.response': 'Response',
    'apiTool.noData': 'No API request data yet',
    'tools.productCard': 'Product Cards',
    'avatar.creator': 'Creator',
    'avatar.voiceAgent': 'Voice Agent',
    'avatar.common': 'Common Avatar',
    'avatar.active': 'Active',
    'avatar.cantEditCommon': 'Cannot edit common avatars. Only super admins can edit common avatars.',
    'avatar.cantDeleteCommon': 'Cannot delete common avatars. Only super admins can delete common avatars.',
    // Avatar tooltips
    // Avatar knowledge management
    // Avatar preview page
    // Bot Test
    'botTest.management': 'Bot Test Management',
    'botTest.list': 'Bot Tests',
    'botTest.create': 'Create Bot Test',
    'botTest.edit': 'Edit Bot Test',
    'botTest.view': 'View Bot Test',
    'botTest.add': 'Add Bot Test',
    'botTest.searchPlaceholder': 'Search bot tests...',
    'botTest.details': 'Test Details',
    'botTest.name': 'Test Name',
    'botTest.testDate': 'Test Date',
    'botTest.description': 'Description',
    'botTest.active': 'Active',
    'botTest.inactive': 'Inactive',
    'botTest.status': 'Status',
    'botTest.testersCount': 'Testers',
    'botTest.targetsCount': 'Targets',
    'botTest.tester': 'Tester',
    'botTest.testers': 'Testers',
    'botTest.targets': 'Test Targets',
    'botTest.messages': 'messages',
    'botTest.noTesters': 'No testers available to run',
    'botTest.addTarget': 'Add Target',
    'botTest.noTargets': 'No targets defined',
    'botTest.selectAvatar': 'Select Avatar',
    'botTest.overrideTesterPrompt': 'Override Tester Prompt',
    'botTest.testerPromptOverride': 'Custom Prompt Override',
    'botTest.showAdvancedTools': 'Advanced Tools',
    'botTest.advancedToolsData': 'Advanced Tools Data (JSON)',
    'botTest.advancedToolsDataPlaceholder': 'Enter tools configuration as JSON...',
    'botTest.addJsonData': 'Add JSON Data',
    'botTest.editJsonData': 'Edit JSON Data',
    'botTest.jsonDataSet': 'JSON set',
    'botTest.messagesCount': 'Messages Count',
    'botTest.model': 'Model',
    'botTest.testerName': 'Tester Name',
    'botTest.temperature': 'Temperature',
    'botTest.prompt': 'Prompt',
    'botTest.defaultTesterName': 'Default Tester',
    'botTest.namePlaceholder': 'Enter bot test name...',
    'botTest.descriptionPlaceholder': 'Enter test description...',
    'botTest.testerNamePlaceholder': 'Enter tester name...',
    'botTest.promptPlaceholder': 'Enter test prompt...',
    'botTest.noTestsFound': 'No bot tests found',
    'botTest.noTestsFoundDesc': 'Start by creating your first bot test to compare different AI configurations.',
    'botTest.failedToLoad': 'Failed to load bot tests',
    'botTest.loadFailed': 'Failed to load bot test',
    'botTest.saveFailed': 'Failed to save bot test',
    'botTest.deleted': 'Bot test deleted successfully',
    'botTest.deleteFailed': 'Failed to delete bot test',
    'botTest.created': 'Bot test created successfully',
    'botTest.updated': 'Bot test updated successfully',
    'botTest.nameRequired': 'Test name is required',
    'botTest.testDateRequired': 'Test date is required',
    'botTest.minimumOneTester': 'At least one tester is required',
    'botTest.noActiveTester': 'No active tester selected',
    'botTest.testerNameRequired': 'Tester name is required',
    'botTest.testerPromptRequired': 'Tester prompt is required',
    'botTest.targetAvatarRequired': 'Target avatar is required',
    'botTest.noAvatarsAvailable': 'No avatars available for testing',
    'botTest.configuration': 'Configuration',
    // Bot Test Preview
    // Bot Test Preview Tabs
    // Bot Test Results
    // Bot Test Results  
    // Price Package List Columns
    'accountGrade.name': 'Name',
    'accountGrade.description': 'Description',
    'accountGrade.price': 'Monthly Price',
    'accountGrade.yearlyPrice': 'Yearly Price',
    'accountGrade.creditsPerMonth': 'Credits per Month',
    'accountGrade.advancedPrompts': 'Advanced Prompts',
    'accountGrade.promptAssist': 'Prompt Assist',
    'accountGrade.maxAvatars': 'Max Avatars',
    'accountGrade.maxUsers': 'Max Users',
    'accountGrade.maxProjectsCount': 'Max Projects',
    'accountGrade.maxKnowledgeEntries': 'Max Knowledge',
    'accountGrade.antiHallucination': 'Anti-Hallucination',
    'accountGrade.advancedReports': 'Advanced Reports',
    'accountGrade.chatThreadSharing': 'Chat Thread Sharing',
    'accountGrade.customBranding': 'Custom Branding',
    'accountGrade.widgets': 'Widgets',
    'accountGrade.customAiModels': 'Custom AI Models',
    'accountGrade.voiceAgent': 'Voice Agent',
    'accountGrade.writingStyles': 'Writing Styles',
    'accountGrade.active': 'Active',
    'accountGrade.order': 'Order',
    // Price Package list page
    'accountGrade.listTitle': 'Price Packages',
    'accountGrade.noAccountGrades': 'No price packages found',
    'accountGrade.noResults': 'No price packages found',
    'accountGrade.addAccountGrade': 'Add Price Package',
    'accountGrade.add': 'Add Price Package',
    'accountGrade.createTitle': 'Create Price Package',
    'accountGrade.searchPlaceholder': 'Search price package...',
    // Price Package form page
    // Price Package form messages
    'accountGrade.loadError': 'Failed to load price package',
    // Price Package sections
    'accountGrade.previewTitle': 'Price Package Preview',
    'accountGrade.basicInfo': 'Basic Information',
    'accountGrade.features': 'Features',
    'accountGrade.status': 'Status',
    'accountGrade.limits': 'Limits',
    'accountGrade.unlimited': 'Unlimited',
    // Account limits and restrictions
    'limits.noAccountGrade': 'No account plan found. Please contact support.',
    'limits.featureDisabled': 'This feature is disabled for your account plan.',
    // Voice chat errors
    'voice_chat.session_timeout': 'Voice conversation session timed out due to inactivity. Please start a new conversation.',
    // Email translations
    // Account upgrade emails
    // Payment success emails
    // Payment failed emails
    // Common payment fields
    // Registration completion
    // Password Reset Page
    // Password Reset Confirm Page
    // Price Package preview page
    // Account upgrade page
    // Price package features
    // Style List Columns
    'style.name': 'Name',
    'style.description': 'Description',
    'style.prompt': 'Prompt',
    'style.common': 'Common Style',
    'style.active': 'Active',
    'style.style': 'Style',
    // Style list page
    'style.listTitle': 'Writing Styles',
    'style.addStyle': 'Add Writing Style',
    'style.searchPlaceholder': 'Search styles...',
    // Style form page
    'style.updated': 'updated',
    'style.created': 'created',
    'style.update': 'update',
    'style.create': 'create',
    'style.failedTo': 'Failed to',
    'style.failedToLoad': 'Failed to load style',
    'style.invalidId': 'Invalid style ID',
    // Style preview page
    'style.metadata': 'Metadata',
    'style.inactive': 'Inactive',
    // Chat demo page
    'chatDemo.title': 'Chat System Demo',
    'chatDemo.intro': 'Complete chat conversation history system has been implemented.',
    'chatDemo.featuresTitle': 'Features Implemented:',
    'chatDemo.openChat': 'Open Chat System',
    'chatDemo.implementationTitle': 'Implementation Details:',
    'chatDemo.backendModels': 'Backend Models:',
    'chatDemo.apiEndpoints': 'API Endpoints:',
    'chatDemo.frontendComponents': 'Frontend Components:',
    // Home page
    'home.dashboardArea': 'DASHBOARD AREA',
    // Common Form Labels
    'form.label': 'Label',
    'form.value': 'Value',
    'form.required': 'Required',
    'form.optional': 'Optional',
    // File upload
    'file.ext': 'file type',
    'file.size': 'file size',
    // Popups
    'popup.error': 'Error',
    'popup.alert': 'Alert',
    'popup.confirm': 'Confirm',
    'popup.ok': 'OK',
    'popup.yes': 'Yes',
    'popup.no': 'No',
    // Table controls
    // ===== LOGIN & REGISTRATION =====
    // Login page
    'login.usernameLabel': 'Login/Email',
    'login.passwordLabel': 'Password',
    'login.forgotPassword': 'Forgot password?',
    'login.submit': 'Sign in',
    // Register page
    'register.nameLabel': 'Name',
    'register.lastNameLabel': 'Last Name',
    'register.usernameLabel': 'Login',
    'register.emailLabel': 'E-mail',
    'register.passwordLabel': 'Password',
    'register.repeatPasswordLabel': 'Repeat Password',
    'register.submit': 'Register',
    // Account Activation page
    // ===== ROUTES =====
    'route.dashboard': 'Dashboard',
    'route.companyManagement': 'Management',
    'route.settings': 'Settings',
    'route.register': 'Register',
    'route.profile': 'Profile',
    'route.team': 'Team',
    'route.assistants': 'Assistants',
    'route.styles': 'Writing Styles',
    'route.ai': 'AI',
    'route.share': 'Shared Conversation',
    // Settings routes
    // Reports routes
    'reports.user': 'User',
    // Management routes
    'route.branches': 'Branches',
    'route.professions': 'Professions',
    'route.steps': 'Steps',
    'route.questions': 'Questions',
    // Avatar routes
    // Style routes
    'route.conversations': 'Conversations',
    'route.conversationList': 'Conversations',
    'route.conversationPreview': 'Conversation Preview',
    'tutorial.noDescription': 'No description available',
    'tutorial.steps': 'steps',
    'tutorial.sections': 'sections',
    'tutorial.noTasks': 'No tasks available for this section',
    'tutorial.created': 'Tutorial created successfully',
    'tutorial.updated': 'Tutorial updated successfully',
    'tutorial.saveFailed': 'Failed to save tutorial',
    'tutorial.loadFailed': 'Failed to load tutorial',
    'tutorial.loadListFailed': 'Failed to load tutorials',
    'tutorial.deleteFailed': 'Failed to delete tutorial',
    'botTest.title': 'Bot Test',
    'botTest.date': 'Date',
    'botTest.addTester': 'Add Tester',
    'ai-assist.header': 'AI Assistant',
    'ai-assist.minimize': 'Minimize',
    'ai-assist.expand': 'Expand',
    'ai-assist.info': 'AI assistant will analyze your prompts and conversations and will provide suggestions to help to obtain better results. You can disable it in chat settings in bottom right corner of chat input area',
    'ai-assist.no-entries': 'Start conversation to activate AI assistant help',
    'modelSelect.instruction': 'Pick your avatar or AI model you want to speak with',
    'modelSelect.knowledgeCreatingInProgress': 'Creating knowledge base entry in progress...',
    // AI Suggestions Component
    // Autocomplete Triggers Component
    // AI Assist Component
    // Model Select Component
    'modelSelect.models': 'Models',
    'modelSelect.avatars': 'Avatars',
    'modelSelect.liveChats': 'Live Chats',
    'modelSelect.voiceModels': 'Voice Models',
    // Conversation translations
    'conversation.demo': 'Voice Agent',
    'conversation.agent': 'Agent',
    'conversation.connected': 'Connected',
    'conversation.disconnected': 'Disconnected',
    'conversation.connecting': 'Connecting...',
    'conversation.voice': 'Voice',
    'conversation.you': 'You',
    'conversation.send': 'Send',
    'conversation_agent.first_word': 'Hello, how can I help you today?',
    'conversation.volume': 'Volume',
    'conversation.debug': 'Debug Information',
    'conversation.language': 'Language',
    'conversation.messages': 'Messages',
    'conversation.started': 'Conversation started successfully!',
    // Share conversation
    'conversation.ended': 'Conversation ended.',
    'conversation.error': 'An error occurred during conversation.',
    'conversation.start': 'Start Conversation',
    'conversation.end': 'End Conversation',
    'recording.start': 'Start Recording',
    'recording.stop': 'Stop Recording',
    'message.used_tools': 'Used Tools',
    'conversations.title': 'Conversations',
    'conversations.loading': 'Loading conversations...',
    'conversations.retry': 'Retry',
    'conversations.empty': 'No conversations found',
    'conversations.chat_history': 'Chat History',
    'conversations.no_conversations_yet': 'No conversations yet',
    'conversations.no_messages_yet': 'No messages yet',
    'conversations.loading_more': 'Loading more...',
    'conversations.no_more_conversations': 'No more conversations',
    'conversations.new_chat': 'New Thread',
    'conversations.listTitle': 'Conversations',
    'conversations.newConversation': 'New Conversation',
    'conversations.search_placeholder': 'Search conversations...',
    'conversations.failedToLoad': 'Failed to load conversations',
    'conversations.failedToLoadMessages': 'Failed to load messages',
    'conversations.last_activity': 'Last Activity',
    'conversations.lastActivity': 'Last Activity',
    'conversations.model': 'Model',
    'conversations.avatar': 'Avatar',
    'conversations.openInChat': 'Open in Chat',
    'conversations.user': 'User',
    'conversations.assistant': 'Assistant',
    'conversations.noMessages': 'No messages in this conversation',
    // Common actions
    'common.create': 'Create',
    'common.update': 'Update',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.clear': 'Clear',
    'common.apply': 'Apply',
    'common.hide': 'Hide',
    'common.moveUp': 'Move Up',
    'common.moveDown': 'Move Down',
    'common.delete': 'Delete',
    'common.results': 'results',
    'common.optional': '(Optional)',
    'common.required': '(Required)',
    'common.none': 'None',
    'common.pay': 'Pay',
    'common.loading': 'Loading...',
    'common.unknown': 'Unknown',
    'common.showing': 'Showing',
    'common.to': 'to',
    'common.of': 'of',
    'common.next': 'Next',
    'common.previous': 'Previous',
    // Account management
    // Price packages
    // Knowledge routes
    'route.onboardings': 'Onboarding',
    // User form
    // User form preview
    // User form errors
    // User profile
    // Register Complete (moved from duplicate section)
    // Routes
    'route.passwordReset': 'Password Reset',
    'route.passwordResetConfirm': 'Reset Password',
    'route.registerComplete': 'Registration Complete',
    'route.activateAccount': 'Activate Account',
    // ===== COMPANY MANAGEMENT =====
    // Company form
    // ===== KNOWLEDGE MANAGEMENT =====
    // Knowledge form
    // Knowledge general (for form-content and other components)
    'knowledge.create': 'Create Knowledge',
    'knowledge.edit': 'Edit Knowledge',
    'knowledge.title': 'Title',
    'knowledge.description': 'Description',
    'knowledge.content': 'Content',
    'knowledge.file': 'File',
    'knowledge.tags': 'Tags',
    'knowledge.project': 'Project',
    'knowledge.creator': 'Creator',
    'knowledge.ragStatus': 'RAG Status',
    'knowledge.assigned': 'Assigned',
    'knowledge.createdAt': 'Created At',
    'knowledge.no_project': 'No Project',
    'knowledge.native': 'Native Knowledge',
    'knowledge.active': 'Active',
    'project.manage': 'Manage Projects',
    'project.none': 'No Project',
    // RAG Status translations
    'knowledge.reindex': 'Re-index',
    'knowledge.reindexingStarted': 'Re-indexing has been started',
    // Knowledge bulk upload
    // Google Drive bulk upload
    // Google Drive bulk upload additional
    // Google Drive bulk upload info
    // Knowledge preview
    'knowledge.preview': 'Knowledge Preview',
    // Knowledge preview sections
    // Knowledge preview content type labels
    // Knowledge preview RAG status labels
    // Knowledge preview active status
    // Knowledge preview usage
    // ===== PROJECTS =====
    // Project form
    // Project general
    'project.name': 'Project Name',
    'project.description': 'Description',
    'project.color': 'Color',
    'project.icon': 'Icon',
    'project.isActive': 'Active',
    'project.preview': 'Preview',
    'project.list': 'Projects',
    'project.create': 'Add Project',
    'project.edit': 'Edit Project',
    'project.creator': 'Creator',
    // ===== BRANCH MANAGEMENT =====
    // Branch list
    'branch.name': 'Name',
    'branch.description': 'Description',
    'branch.color': 'Color',
    'branch.create': 'Create Branch',
    // Branch form
    'branch.form.error.load_failed': "Failed to load branch",
    'branch.form.error.action_failed': "Action failed",
    'branch.form.error.general_error': "An error occurred",
    'branch.form.action.updated': "updated",
    'branch.form.action.created': "created",
    'branch.form.action.update': "update",
    'branch.form.action.create': "create",
    'branch.form.success.updated': "Branch updated successfully",
    'branch.form.success.created': "Branch created successfully",
    'branch.form.success.action_completed': "Action completed",
    // ===== PROFESSION MANAGEMENT =====
    // Profession list
    'profession.name': 'Name',
    'profession.description': 'Description',
    'profession.branch': 'Branch',
    'profession.create': 'Create Profession',
    // Profession form
    // ===== STEP MANAGEMENT =====
    // Step list
    'step.title': 'Title',
    'step.description': 'Description',
    'step.order': 'Order',
    'step.isShared': 'Shared',
    'step.profession': 'Profession',
    'step.create': 'Create Step',
    // Step form
    // ===== QUESTION MANAGEMENT =====
    // Question list
    'question.title': 'Title',
    'question.description': 'Description',
    'question.type': 'Type',
    'question.required': 'Required',
    'question.order': 'Order',
    'question.step': 'Step',
    'question.create': 'Create Question',
    // Question form (question manager)
    // Question types
    // ===== ONBOARDING =====
    // Onboarding intro
    // Onboarding list
    'onboarding.avatar': 'Avatar',
    'onboarding.profession': 'Profession',
    'onboarding.status': 'Status',
    'onboarding.currentStep': 'Current Step',
    'onboarding.createdAt': 'Created',
    'onboarding.create': 'Start Onboarding',
    'onboarding.filter': 'Filter',
    'onboarding.progress': 'Progress',
    'onboarding.createdBy': 'Created By',
    // Onboarding status
    // Onboarding stats
    // Onboarding wizard
    // Onboarding component
    'onboarding.title': 'Onboarding',
    'onboarding.loading': 'Loading...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': 'fields completed',
    // Chat component
    // ===== LLM TRAINER =====
    'trainer.title': 'LLM Model Trainer',
    'training_jobs.list': 'Training Jobs',
    'trainer.listTitle': 'Trainer List',
    'trainer.jobId': 'Job ID',
    'trainer.modelName': 'Model Name',
    'trainer.trainingType': 'Training Type',
    'trainer.status': 'Status',
    'trainer.createdAt': 'Created At',
    'trainer.updatedAt': 'Updated At',
    'trainer.addJob': 'Add Job',
    // Upload component
    // Manual entry
    // PDF processing
    // Config component
    // Progress component
    // Results component
    // Instructions component
    // ===== MISC =====    
    'knowledge': 'knowledge',
    'code-viewer.show_code': 'Show code',
    'code-viewer.hide_code': 'Hide code',
    'code-viewer.writing_code': 'Writing code',
    // Branch translations    
    'profession.common': 'Common',
    'profession.creator': 'Creator',
    // Step translations   
    'step.creator': 'Creator',
    'actions': 'Actions',
    'view': 'View',
    'edit': 'Edit',
    'delete': 'Delete',
    'loading': 'Loading...',
    // Settings translations
    'settings.saveButton': 'Save Settings',
    'settings.savedSuccessfully': 'Settings saved successfully',
    'settings.failedToSave': 'Failed to save settings',
    'settings.failedToLoad': 'Failed to load settings',
    // Settings Tabs
    // General Settings - Chat Learning
    // RAG Settings
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // Google Drive Settings
    // Google Drive File Picker
    // Google Drive Directory Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Resource translations
    'resource.active': 'Active',
    // Generated Image Component
    'gen-image.noData': 'No image data provided',
    'gen-image.invalidData': 'Invalid image data format',
    'gen-image.loadError': 'Failed to load image',
    'gen-image.loading': 'Loading image...',
    'gen-image.altText': 'Generated image',
    'gen-image.download': 'Download',
    'gen-image.copyToClipboard': 'Copy to clipboard',
    // File Card Component
    'file-card.errorLoading': 'Failed to load file',
    'file-card.unknownFile': 'Unknown file',
    'file-card.unknownSize': 'Unknown size',
    'file-card.download': 'Download',
    'file-card.addToKdb': 'Add to Knowledge Base',
    'file-card.videoNotSupported': 'Your browser does not support the video tag.',
    'file-card.zoomHint': 'click to enlarge',
    'file-card.zoom': 'Enlarge',
    'file-card.close': 'Close',
    // Reports and Cost Analytics
    'reports.totalCost': 'Total Cost',
    'reports.totalMessages': 'Total Messages',
    'reports.avgCostPerMessage': 'Avg. Cost/Message',
    'reports.totalTokens': 'Total Tokens',
    'reports.filters': 'Filters',
    'reports.startDate': 'Start Date',
    'reports.endDate': 'End Date',
    'reports.userName': 'User Name',
    'reports.companyName': 'Company Name',
    'reports.userNamePlaceholder': 'Filter by user name...',
    'reports.companyNamePlaceholder': 'Filter by company name...',
    'reports.avatarNamePlaceholder': 'Filter by avatar name...',
    'reports.date': 'Date',
    'reports.promptTokens': 'Prompt Tokens',
    'reports.completionTokens': 'Completion Tokens',
    'reports.cost': 'Cost',
    'reports.cost_type': 'Query Type',
    'reports.company': 'Company',
    'reports.upstreamCost': 'Upstream Cost',
    'reports.reasoningTokens': 'Reasoning Tokens',
    'reports.cachedTokens': 'Cached Tokens',
    'reports.noData': 'No cost data available',
    'reports.noDataDescription': 'No usage cost data found for the selected criteria.',
    'reports.failedToLoad': 'Failed to load cost data',
    'reports.loadingError': 'Failed to load cost data',
    'reports.costTrends': 'Cost & Token Trends',
    'reports.showChart': 'Show Chart',
    'reports.tokens': 'Tokens',
    'report.usage_cost_data': 'Usage Cost Data',
    'reports.userSummary': 'User Summary Statistics',
    'reports.avatarUsage': 'Avatar Usage Statistics',
    'reports.messageCount': 'Messages',
    'reports.avgTokensPerMessage': 'Avg. Tokens/Message',
    'reports.firstUsage': 'First Usage',
    'reports.lastUsage': 'Last Usage',
    // Cost Preview
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': 'Document full scan will put entire file in prompt resulting in more expensive and longer response',
    // Icon Picker
    'iconPicker.selectIcon': 'Select an icon',
    'iconPicker.clear': 'Clear selection',
    'iconPicker.searchPlaceholder': 'Search icons...',
    'iconPicker.noResults': 'No icons found',
    'iconPicker.resultsLimited': 'Results limited to 100 icons. Use search to narrow down.',
    // AI Assistant Context
    'context.userMessages': 'user messages',
    'context.assistantMessages': 'assistant messages',
    'context.activeEntries': 'active entries',
    'context.summary': 'Context',
    'context.empty': 'No context available',
    'context.validationError': 'Context validation error',
    // Reports
    'and': 'and',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': 'Manage company settings and information',
    'acl_resource_desc.user': 'Manage user accounts and profiles',
    'acl_resource_desc.user_group': 'Manage user groups and their permissions',
    'acl_resource_desc.settings_general': 'Access to general application settings',
    'acl_resource_desc.settings_access': 'Manage access control and security settings',
    'acl_resource_desc.settings_styles': 'Manage writing styles and templates',
    'acl_resource_desc.avatar': 'Create and manage AI avatars and assistants',
    'acl_resource_desc.ai': 'Access to AI models and configurations',
    'acl_resource_desc.knowledge': 'Manage knowledge base and information resources',
    'acl_resource_desc.project': 'Create and manage projects and workflows',
    'acl_resource_desc.onboarding': 'Manage user onboarding processes and templates',
    'acl_resource_desc.reports': 'Generate and view system reports and analytics',
    // ACL Action Descriptions
    'acl_action_desc.read': 'View and access information without making changes',
    'acl_action_desc.write': 'Create, edit, and modify content and settings',
    'acl_action_desc.delete': 'Remove and permanently delete items from the system',
    // V-Select Component
    'v-select.createNew': 'Create new',
    'v-select.noOptions': 'No options available',
    'v-select.clear': 'Clear selection',
    // Keyboard shortcuts
    'shortcuts.title': 'Keyboard Shortcuts',
    'shortcuts.tooltip-text': 'View available keyboard shortcuts',
    // Currency
    // Navigation
    'nav.credits': 'Credits',
    // Tools
    'tools.toolLabel': 'Tool',
    'tools.activeTools': 'Active Tools',
    'tools.expandAll': 'Expand All',
    'tools.collapseAll': 'Collapse All',
    'tools.unknownTool': 'Unknown tool',
    'tools.noActiveTools': 'No active tools',
    'tools.webSearch': 'Web Search',
    'tools.rag': 'Knowledge Base',
    'webSearch.searching': 'Searching web for',
    'webSearch.toolData': 'Web Search Data',
    'webSearch.searchingFor': 'Searching for',
    'webSearch.resultsFound': 'results found',
    'webSearch.noResultsFound': 'No results found',
    'webSearch.tryDifferentQuery': 'Try a different search query',
    'webSearch.deepSearchEnabled': 'Deep Search Enabled',
    'webSearch.contentExtracted': 'Content extracted from',
    'webSearch.pages': 'pages',
    'webSearch.characters': 'characters',
    'rag.searchingKnowledge': 'Searching knowledge base',
    'rag.open_knowledge_preview': 'Open knowledge preview',
    'rag.openInKnowledgeBase': 'Preview',
    'rag.noFilesIncluded': 'No files included',
    'rag.sources_used': 'Sources used',
    'rag.sources': 'Sources',
    'rag.open_sources': 'View sources',
    // Product Cards
    'productCard.toolData': 'Product Cards',
    'productCard.productList': 'Product List',
    'productCard.singleProduct': 'Single Product',
    'productCard.product': 'product',
    'productCard.products': 'products',
    'productCard.grossPrice': 'Gross Price',
    'productCard.netPrice': 'Net Price',
    'productCard.vat': 'VAT',
    'productCard.category': 'Category',
    'productCard.viewProduct': 'View Product',
    'productCard.noProducts': 'No products found',
    'productCard.trySearching': 'Try searching for products',
    // Product Compare Tool
    'productCompare.domain': 'Domain',
    'productCompare.comparing': 'Comparing',
    'productCompare.searchQuery': 'Search query',
    'productCompare.noResults': 'No comparison results found',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': 'Phone Numbers',
    'detectContactData.emails': 'Emails',
    'detectContactData.addresses': 'Addresses',
    'detectContactData.names': 'Names',
    'detectContactData.companies': 'Companies',
    'detectContactData.socialMedia': 'Social Media',
    'detectContactData.websites': 'Websites',
    'detectContactData.other': 'Other',
    'detectContactData.noData': 'No contact data detected',
    // Detect Tasks Tool
    'detectTasks.notes': 'Notes',
    'detectTasks.noTasks': 'No tasks detected',
    // Offer Creator Tool
    'offerCreator.companyName': 'Company Name',
    'offerCreator.firstName': 'First Name',
    'offerCreator.lastName': 'Last Name',
    'offerCreator.email': 'Email',
    'offerCreator.phone': 'Phone',
    'offerCreator.vatPayer': 'VAT Payer',
    'offerCreator.employeesNumber': 'Number of Employees',
    'offerCreator.businessActivity': 'Business Activity',
    'offerCreator.taxationType': 'Taxation Type',
    'offerCreator.documentsNumber': 'Number of Documents',
    'offerCreator.packageId': 'Package',
    'offerCreator.additionalInfo': 'Additional Info',
    'offerCreator.formSent': 'Form submitted',
    'offerCreator.noData': 'No offer data collected',
    // Quick Offer Tool
    'quickOffer.availableOptions': 'Available Options',
    'quickOffer.formSent': 'Form submitted',
    'quickOffer.noFields': 'No form fields',
    // Send Contact Form Tool
    'sendContactForm.name': 'Name',
    'sendContactForm.email': 'Email',
    'sendContactForm.phone': 'Phone',
    'sendContactForm.message': 'Message',
    'sendContactForm.formSent': 'Contact form submitted',
    'sendContactForm.noData': 'No contact form data',
    // Conversation Tags Tool
    'convoTags.noTags': 'No tags detected',
    // Gallery Tags Tool
    'galleryTags.noTags': 'No gallery tags detected',
    // Ask For Voucher Tool
    'askForVoucher.detected': 'Voucher request detected',
    'askForVoucher.notDetected': 'No voucher request detected',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': 'listings signalled',
    'dynamicListings.allListings': 'All listings signalled',
    // Product API Search Tool
    'productAPISearch.searchQuery': 'Search query',
    'productAPISearch.totalResults': 'total results',
    'productAPISearch.subcategories': 'subcategories',
    'productAPISearch.noResults': 'No results found',
    // Model Selector - removed duplicates
    // Google Drive
    // Knowledge Bulk Upload
    // DB Logs page
    'dblogs.title': 'DB Audit Logs',
    'dblogs.show': 'Show',
    'dblogs.hide': 'Hide',
    'dblogs.empty': 'No log entries found.',
    // DB model collection names
    'model.user': 'User',
    'model.user_group': 'User Group',
    'model.api_keys': 'API Keys',
    'model.acl_policy': 'ACL Policy',
    'model.company': 'Company',
    'model.conversation': 'Conversation',
    'model.message': 'Message',
    'model.avatar': 'Avatar',
    'model.user_avatar': 'User Avatar',
    'model.knowledge': 'Knowledge',
    'model.knowledgeGroup': 'Knowledge Group',
    'model.file': 'File',
    'model.training_job': 'Training Job',
    'model.avatar_knowledge': 'Avatar Knowledge',
    'model.avatar_instruction': 'Avatar Instruction',
    'model.avatar_instruction_version': 'Avatar Instruction Version',
    'model.profession_knowledge': 'Profession Knowledge',
    'model.profession_step': 'Profession Step',
    'model.custom_models': 'Custom Model',
    'model.embeddings': 'Embedding',
    'model.branch': 'Branch',
    'model.profession': 'Profession',
    'model.step': 'Step',
    'model.step_profession': 'Step Profession',
    'model.onboarding': 'Onboarding',
    'model.db_logs': 'DB Log',
    'model.question': 'Question',
    'model.answer': 'Answer',
    'model.settings': 'Settings',
    'model.usage_cost': 'Usage Cost',
    'model.knowledge_elevenlabs_mappings': 'Knowledge ElevenLabs Mapping',
    'model.front_sync': 'Front Sync',
    'model.favorite_conversation': 'Favorite Conversation',
    'model.style': 'Style',
    'model.slotData': 'Slot Data',
    'model.payments': 'Payment',
    'model.account_balance': 'Account Balance',
    'model.accountGrade': 'Account Grade',
    'model.currencyRate': 'Currency Rate',
    'model.test_result': 'Test Result',
    'model.bot_test': 'Bot Test',
    'model.bot_test_tester': 'Bot Test Tester',
    'model.bot_test_target': 'Bot Test Target',
    'model.tutorial': 'Tutorial',
    'model.tutorial_step': 'Tutorial Step',
    'model.tutorial_section': 'Tutorial Section',
    'model.tutorial_section_knowledge': 'Tutorial Section Knowledge',
    'model.tutorial_section_todo': 'Tutorial Section Todo',
    'model.tutorial_participants': 'Tutorial Participant',
    'model.todo': 'Todo',
    'model.todo_item': 'Todo Item',
    'model.todo_item_value': 'Todo Item Value',
    'model.cache': 'Cache',
    'model.api_tool_definition': 'API Tool Definition',
    // DB operation names
    // WhatsApp settings
    "route.settings.comms": "Communications",
    "route.settings.comms.create": "Create Communication",
    "route.settings.comms.edit": "Edit Communication",
    "route.settings.comms.manage": "Manage Communication",
    "route.settings.comms.group": "Group Details",
    "route.settings.comms.group.create": "Create Group",
    "route.settings.comms.dm": "Direct Message Contact",
    'socialMediaPlan.title': 'Content Studio',
    'socialMediaPlan.failedToLoad': 'Failed to load posts',
    'socialMediaPlan.newPost': 'New post',
    'socialMediaPlan.library': 'Post Library',
    'socialMediaPlan.search': 'Search post or topic...',
    'socialMediaPlan.edit': 'Edit',
    'socialMediaPlan.ai.placeholder': "Ask e.g. 'Suggest 3 Instagram post ideas'...",
    'socialMediaPlan.schedule.action': "What's next?",
    'socialMediaPlan.back': 'Back',
    'socialMediaPlan.next': 'Next',
    'socialMediaPlan.cancel': 'Cancel',
    'socialMediaPlan.save': 'Save & confirm',
    'socialMediaPlan.close': 'Close',
    'whatsapp.loginFailed': 'WhatsApp login failed.',
    'whatsapp.logoutSuccess': 'WhatsApp logged out successfully.',
    'whatsapp.logoutFailed': 'WhatsApp logout failed.',
    'whatsapp.failedToLoad': 'Failed to load WhatsApp status.',
    'whatsapp.entityIdRequired': 'Entity ID is required.',
    'whatsapp.phoneRequired': 'Phone number is required.',
    'whatsapp.settingsSaved': 'WhatsApp settings saved successfully.',
    'whatsapp.settingsSaveFailed': 'Failed to save WhatsApp settings.',
    'whatsapp.agentStarted': 'WhatsApp agent started successfully.',
    'whatsapp.agentStartFailed': 'Failed to start WhatsApp agent.',
    'whatsapp.agentStopped': 'WhatsApp agent stopped successfully.',
    'whatsapp.agentStopFailed': 'Failed to stop WhatsApp agent.',
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp groups
    // WhatsApp track logs
    // Activity panels
    // WhatsApp group form
    // WhatsApp dashboard
    // WhatsApp group routes
    // WhatsApp direct messages
    // WhatsApp DM detail page
    // Email Reporting Settings
    'whatsapp.pop3SettingsSaved': 'Email settings saved successfully.',
    'whatsapp.pop3SettingsSaveFailed': 'Failed to save email settings.',
    // Gmail OAuth
    // ACL translations
    ...en_1.aclTranslationsEn
};
